import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["data-cy"];
const _hoisted_2 = {
  key: 1,
  class: "flex justify-between",
  "data-replay-unmask": ""
};
import { reactive, ref, watch } from 'vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import LlSelect from '@/components/LlSelect.vue';
import LlTextField from '@/components/LlTextField.vue';
import { storeToRefs } from 'pinia';
export default {
  __name: 'RateAdjustOptions',
  props: {
    isPanel: {
      type: Boolean,
      required: false,
      default: false
    },
    form: {
      type: Object,
      required: false
    },
    rateList: {
      type: Array,
      required: false
    },
    rateRules: {
      type: Array,
      required: false,
      default: () => []
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: true
    },
    showAdjustRateText: {
      type: Boolean,
      required: false,
      default: true
    },
    isModal: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:form', 'adjustRateToSelection'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      permissions,
      me
    } = storeToRefs(useMeStore());
    const emit = __emit;
    const props = __props;
    const state = reactive({
      enabled: props.showAdjustRateText ? false : true
    });
    const localAmount = ref(props.form.rate?.amount || 0);
    const invoiceEmailStatusToggle = () => {
      state.enabled = !state.enabled;
    };
    watch(() => props.form.rate?.amount, newAmount => {
      const numericAmount = parseFloat(newAmount) || 0;
      if (localAmount.value !== numericAmount) {
        localAmount.value = numericAmount;
      }
    }, {
      immediate: true
    });
    const rateChanged = selectedRate => {
      if (selectedRate) {
        // DO NOT set edited flag here - let handleRateChangeUpdate in EditEntry.vue determine it
        // based on whether this rate matches the system-determined default baseline.
        // We pass the rate without any edited property so the parent logic has full control.
        const updatedForm = {
          ...props.form,
          rate: {
            label: selectedRate.label,
            amount: selectedRate.amount
          }
        };
        emit('update:form', updatedForm);
      }
      // DO NOT emit 'adjustRateToSelection' here - it causes the selection to be reset!
      // This emit should only happen when we need to refresh the rate list, not when user selects a rate
    };
    const manualRateChanged = newAmount => {
      let customRate = props.rateList.find(x => x.label === 'Custom');
      if (!customRate) {
        customRate = {
          label: 'Custom',
          amount: parseFloat(newAmount) || 0,
          edited: true
        };
        props.rateList.push(customRate);
      } else {
        customRate.amount = parseFloat(newAmount) || 0;
        customRate.edited = true;
      }
      const updatedForm = {
        ...props.form,
        rate: customRate
      };
      emit('update:form', updatedForm);
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(permissions).time?.viewRates && (__props.form.billingType?.id || __props.form.billingType) === 'billable' && __props.showAdjustRateText ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "flex py-1",
        "data-cy": _ctx.$attrs['data-cy']
      }, [_createElementVNode("div", {
        class: "py-1.5 px-1 cursor-pointer text-sm",
        "data-cy": "adjust-rate-toggle",
        onClick: _cache[0] || (_cache[0] = $event => invoiceEmailStatusToggle())
      }, " Adjust Rate "), _createElementVNode("div", {
        class: "py-1.5 px-1 cursor-pointer",
        onClick: _cache[1] || (_cache[1] = $event => invoiceEmailStatusToggle())
      }, [_createVNode(_component_v_icon, {
        class: "no-print"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(state.enabled ? 'mdi-chevron-down' : 'mdi-chevron-right'), 1)]),
        _: 1
      })])], 8, _hoisted_1)) : _createCommentVNode("", true), state.enabled && _unref(permissions).time?.viewRates && (__props.form.billingType?.id || __props.form.billingType) === 'billable' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_v_row, {
        justify: "space-between",
        class: "tw number-input",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_v_col, {
          cols: __props.isPanel ? 8 : __props.isModal ? 6 : 4,
          class: _normalizeClass(["remove-all-input-styling", __props.isModal ? '' : 'pr-2'])
        }, {
          default: _withCtx(() => [_createVNode(LlSelect, {
            modelValue: __props.form.rate,
            "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => __props.form.rate = $event), rateChanged],
            items: __props.rateList,
            "item-title": "label",
            "item-value": "amount",
            "return-object": true,
            disabled: !_unref(permissions).time?.editRates,
            "data-cy": "rate-select"
          }, null, 8, ["modelValue", "items", "disabled"])]),
          _: 1
        }, 8, ["cols", "class"]), _createVNode(_component_v_col, {
          cols: __props.isModal ? 6 : 4,
          class: "pl-2"
        }, {
          default: _withCtx(() => [_createVNode(LlTextField, {
            disabled: !_unref(permissions).time?.editRates || __props.form.billed || __props.form.saving,
            type: "number",
            modelValue: localAmount.value,
            "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => localAmount.value = $event), manualRateChanged],
            step: 0.01,
            rules: __props.rateRules,
            "hide-details": __props.hideDetails,
            "incoming-class": "pt-1.5",
            "data-cy": "manual-rate-input"
          }, null, 8, ["disabled", "modelValue", "rules", "hide-details"])]),
          _: 1
        }, 8, ["cols"])]),
        _: 1
      })])) : _createCommentVNode("", true)], 64);
    };
  }
};